import {FC} from "react";
import {UnityPatrolTabContent} from "./content";
import {Unity} from "../../../../domain/unity";
import {useOutletContext} from "react-router-dom";

export const UnityPatrol: FC = () => {
    const unity = useOutletContext() as Unity;
    return <UnityPatrolTabContent unity={unity}/>;
};
